export const DEEP_CLEAN_ITEMS = [
    ['OVEN', 'Oven'], ['CARPET', 'Carpet'], ['BATHROOM_1', 'Bathroom 1'], ['BATHROOM_2', 'Bathroom 2'],
    ['BALCONY', 'Balcony'], ['BALCONY_GLASS', 'Balcony glass'], ['STOVETOP', 'Stovetop'], ['RANGEHOOD', 'Rangehood'],
];
export const statusColor = (status) => status === 'CLOSED' || status === 'DONE' ? '#23783a' : status === 'BLOCKED' ? '#9a6700' : '#bb2525';
export const itemName = (code) => DEEP_CLEAN_ITEMS.find(item => item[0] === code)?.[1] || code.replaceAll('_', ' ');
